import { useAnimatedStyle } from "@-/com.npmjs.react-native-reanimated";

export function useDrillPageKeyboardAwareContentStyle() {
  // No translate: the content column is anchored to the top of its area whenever a keyboard is open
  // (see DrillPagePortraitView) and the glyph block shrinks to the room it measures above the
  // keyboard (see DrillPageGlyphBlock), so the header/character stay fully visible without lifting the
  // content — which previously pushed the header up under the app header and clipped it.
  const keyboardAwareContentStyle = useAnimatedStyle(() => ({}));

  return { keyboardAwareContentStyle };
}
